export enum PrescriptionType {
    SUPPLY_FARM_ANIMAL_TREATMENT = 'SUPPLY_FARM_ANIMAL_TREATMENT',
    SINGLE_FARM_ANIMAL_TREATMENT = 'SINGLE_FARM_ANIMAL_TREATMENT'
}